import React from 'react';
import { BadgeCheckIcon, StarIcon } from 'lucide-react';
import { LaunchUrgency } from './LaunchUrgency';
import { Section, CTAButton } from './Shared';
export function Pricing() {
  return <Section id="pricing" className="mt-10 max-w-4xl rounded-3xl border border-brand-green/20 bg-brand-surfaceLight/55" data-id="element-259" data-mp="2oiftjbnj6wa9">
      <LaunchUrgency data-id="element-260" data-mp="2jknqpmlclpra" />
      <header className="text-center" data-id="element-261" data-mp="2jk5wevi8xlm0">
        <h2 className="font-display text-4xl font-bold text-brand-dark md:text-5xl" data-id="element-262" data-mp="1vu1vwx0cu1z8">
          Soluciona tus consultas desde hoy
        </h2>
        <p className="mt-3 text-sm text-brand-muted" data-id="element-263" data-mp="1rthv9jgkog8c">
          Después de que termine el lanzamiento, el precio sube a $38.990 ARS.
        </p>
      </header>
      <article className="relative mx-auto mt-9 max-w-2xl overflow-hidden rounded-3xl border-2 border-brand-green bg-brand-cream p-6 shadow-[0_16px_36px_rgba(23,59,43,.14)] md:p-9" data-id="element-264" data-mp="20t4rzrycwxv2">
        <span className="absolute right-0 top-0 rounded-bl-xl bg-brand-yellow px-4 py-1.5 text-xs font-bold text-brand-deep" data-id="element-265" data-mp="3h97lfwxkcyrs">
          MÁS ELEGIDO
        </span>
        <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[.12em] text-brand-green" data-id="element-266" data-mp="3vynj6hf3w1bz">
          <BadgeCheckIcon className="h-4 w-4" data-id="element-267" data-mp="4raznvqr3bsw" />
          Acceso completo
        </div>
        <h3 className="mt-5 font-serif text-2xl font-bold text-brand-dark md:text-3xl" data-id="element-268" data-mp="9tjt0t7jcfvj">
          CÓDIGO HEPÁTICO™
        </h3>
        <p className="mt-1 text-sm text-brand-muted" data-id="element-269" data-mp="ep8wh7moegx4">
          1 Ebook Principal + 3 Bonus
        </p>
        <p className="mt-4 text-sm leading-relaxed text-brand-text" data-id="element-270" data-mp="3d74fs9h66l9f">
          Ideal para: terapeutas que trabajan con el cuerpo y las emociones y
          quieren integrar un protocolo concreto de salud hepática en su
          práctica profesional desde hoy.
        </p>
        <div className="mt-6 flex items-end justify-between gap-4" data-id="element-271" data-mp="3rzeo998bxxeu">
          <span className="text-sm font-medium text-brand-muted" data-id="element-272" data-mp="2uj98n8g2c5pa">
            Inversión única
          </span>
          <div className="text-right" data-id="element-273" data-mp="2zgiy2o3gchd4">
            <p className="text-sm text-brand-muted line-through" data-id="element-274" data-mp="2zf7ryhmjaxiu">
              $348.000 ARS
            </p>
            <p className="font-display text-4xl font-bold leading-none text-brand-green" data-id="element-275" data-mp="2mhrufshspo58">
              $20.990 ARS
            </p>
          </div>
        </div>
        <CTAButton fullWidth href="https://renacer-hepatico.impultienda.ar/checkout" className="animate-glow-pulse mt-8" data-id="element-276" data-mp="3164sqw4cvj2w">
          LO QUIERO — $20.990
        </CTAButton>
        <p className="mt-4 text-center text-xs text-brand-muted" data-id="element-277" data-mp="28h7ceyjpfwcs">
          Garantía 7 días · Descarga inmediata · Pago seguro · Mercado Pago
        </p>
      </article>
    </Section>;
}